<rr-start-logo color="inverse" routerLink="/"></rr-start-logo>
<div class="confirmemail">
    <span i18n
        >Please wait while your email is being confirmed.<br />After that, you
        will be redirected automatically.</span
    >
    <img src="images/spinner_black.gif" style="width: 50px" alt="" />
</div>
